import Moment from 'moment';
import { extendMoment } from 'moment-range';

export function createDateRange(startDate, endDate) {
  const moment = extendMoment(Moment);
  let range = moment().range(startDate, endDate);

  return Array.from(range.by('days')).map(m => m.format('YYYY-MM-DD'));
}